import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { Role } from "../../../models/role.model"
import { Permission } from "../../../models/permission.model"

export interface Auth {
  loading: boolean
  role: Role | null
  permission: Permission[] | null
}

const validateJson = () => {
  if (localStorage?.currentRole) {
    try {
      return JSON.parse(localStorage.currentRole)
    } catch (e) {
      localStorage.removeItem("currentRole")
      return null
    }
  }
}

const validatePermissions = () => {
  if (localStorage?.userRolePermissions) {
    try {
      return JSON.parse(localStorage.userRolePermissions)
    } catch (e) {
      localStorage.removeItem("userRolePermissions")
      return null
    }
  }
}

const initialState: Auth = {
  loading: false,
  role: validateJson(),
  permission: validatePermissions(),
}

export const authSlice = createSlice({
  name: "authLoading",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>): void => {
      state.loading = action.payload
    },
    setRole: (state, action: PayloadAction<Role>): void => {
      state.role = action.payload
    },
    setPermission: (state, action: PayloadAction<Permission[]>): void => {
      state.permission = action.payload
    },
  },
})
// Action creators are generated for each case reducer function
export const { setLoading, setRole, setPermission } = authSlice.actions
export default authSlice.reducer
